import React from 'react'
import {
  SingleCard,
  CardText,
  CardValue,
  TopHeader,
  CursorPointer
} from 'components/InfoCards/style'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import ArrowForward from 'components/icons/ArrowForward'
import { useNavigate } from 'react-router-dom'

const InfoCards = ({
  background = COLORS.BLUE_T_95,
  padding = '15px 25px',
  width = 'auto',
  icon,
  text,
  clickIcon,
  navigation,
  value,
}) => {
  const navigate = useNavigate()
  const clickedFn = () =>{
    navigate(navigation)
  }
  return (
    <SingleCard
      background={background}
      padding={padding}
      width={width}
      column
      flexStart
    >
      {icon}
      <CardText>{text}</CardText>
      <TopHeader row spaceBetween alignCenter>
        <Flex flexStart>
          <CardValue>{value}</CardValue>
        </Flex>

        <Flex flexEnd>{clickIcon && 
        <CursorPointer onClick={clickedFn}>
        <ArrowForward />
        </CursorPointer>
      }</Flex>
      </TopHeader>
    </SingleCard>
  )
}

export default InfoCards
